// extracted by mini-css-extract-plugin
export default {"buttonContainer":"BlockedRecipients_buttonContainer__LVby"};